import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { UserService } from '../../shared/services/user.service';

export const need4SteelUserGuard: CanActivateFn = () => {
	const userService = inject(UserService);
	return userService.user.hasService('ND4ST');
};
